import useQueryParamKey from './useQueryParamKey';

export default useQueryParamKey;
